// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Invoice,
    InvoiceFromJSON,
    InvoiceToJSON,
    SupportAIPhone,
    SupportAIPhoneFromJSON,
    SupportAIPhoneToJSON,
    SupportClaim,
    SupportClaimFromJSON,
    SupportClaimToJSON,
    SupportClaimEligibility,
    SupportClaimEligibilityFromJSON,
    SupportClaimEligibilityToJSON,
    SupportClaimPayment,
    SupportClaimPaymentFromJSON,
    SupportClaimPaymentToJSON,
    SupportClaimTransmission,
    SupportClaimTransmissionFromJSON,
    SupportClaimTransmissionToJSON,
    SupportCoding,
    SupportCodingFromJSON,
    SupportCodingToJSON,
    SupportCollectionInvoiceEvent,
    SupportCollectionInvoiceEventFromJSON,
    SupportCollectionInvoiceEventToJSON,
    SupportCollectionPayment,
    SupportCollectionPaymentFromJSON,
    SupportCollectionPaymentToJSON,
    SupportComment,
    SupportCommentFromJSON,
    SupportCommentToJSON,
    SupportDocument,
    SupportDocumentFromJSON,
    SupportDocumentToJSON,
    SupportHL7Message,
    SupportHL7MessageFromJSON,
    SupportHL7MessageToJSON,
    SupportInstitutionalClaim,
    SupportInstitutionalClaimFromJSON,
    SupportInstitutionalClaimToJSON,
    SupportLetter,
    SupportLetterFromJSON,
    SupportLetterToJSON,
    SupportMail,
    SupportMailFromJSON,
    SupportMailToJSON,
    SupportMessage,
    SupportMessageFromJSON,
    SupportMessageToJSON,
    SupportPhone,
    SupportPhoneFromJSON,
    SupportPhoneToJSON,
    SupportProfessionalClaim,
    SupportProfessionalClaimFromJSON,
    SupportProfessionalClaimToJSON,
    SupportReceiveFax,
    SupportReceiveFaxFromJSON,
    SupportReceiveFaxToJSON,
    SupportSendEmail,
    SupportSendEmailFromJSON,
    SupportSendEmailToJSON,
    SupportSendFax,
    SupportSendFaxFromJSON,
    SupportSendFaxToJSON,
    SupportStatus,
    SupportStatusFromJSON,
    SupportStatusToJSON,
    SupportTagRecord,
    SupportTagRecordFromJSON,
    SupportTagRecordToJSON,
} from './';

/**
 * Claim details
 * @export
 * @interface SupportClaimDetails
 */
export interface SupportClaimDetails {
    /**
     * 
     * OpenAPI data type: {SupportClaim}
     * @type {SupportClaim}
     * @memberof SupportClaimDetails
     */
    claim?: SupportClaim;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportCoding>}
     * @memberof SupportClaimDetails
     */
    codings?: Array<SupportCoding>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportHL7Message>}
     * @memberof SupportClaimDetails
     */
    hl7s?: Array<SupportHL7Message>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportCollectionPayment>}
     * @memberof SupportClaimDetails
     */
    collectionPayments?: Array<SupportCollectionPayment>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportClaimPayment>}
     * @memberof SupportClaimDetails
     */
    payments?: Array<SupportClaimPayment>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportClaimEligibility>}
     * @memberof SupportClaimDetails
     */
    eligibilities?: Array<SupportClaimEligibility>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportStatus>}
     * @memberof SupportClaimDetails
     */
    statuses?: Array<SupportStatus>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportProfessionalClaim>}
     * @memberof SupportClaimDetails
     */
    professionals?: Array<SupportProfessionalClaim>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportClaimTransmission>}
     * @memberof SupportClaimDetails
     */
    transmissions?: Array<SupportClaimTransmission>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportInstitutionalClaim>}
     * @memberof SupportClaimDetails
     */
    institutionals?: Array<SupportInstitutionalClaim>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportDocument>}
     * @memberof SupportClaimDetails
     */
    documents?: Array<SupportDocument>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportSendFax>}
     * @memberof SupportClaimDetails
     */
    sendFaxes?: Array<SupportSendFax>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportReceiveFax>}
     * @memberof SupportClaimDetails
     */
    receiveFaxes?: Array<SupportReceiveFax>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportLetter>}
     * @memberof SupportClaimDetails
     */
    letters?: Array<SupportLetter>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<Invoice>}
     * @memberof SupportClaimDetails
     */
    invoices?: Array<Invoice>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportCollectionInvoiceEvent>}
     * @memberof SupportClaimDetails
     */
    collectionInvoiceEvents?: Array<SupportCollectionInvoiceEvent>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportTagRecord>}
     * @memberof SupportClaimDetails
     */
    historicalTagRecords?: Array<SupportTagRecord>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportPhone>}
     * @memberof SupportClaimDetails
     */
    phones?: Array<SupportPhone>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportAIPhone>}
     * @memberof SupportClaimDetails
     */
    aiPhones?: Array<SupportAIPhone>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportMail>}
     * @memberof SupportClaimDetails
     */
    mails?: Array<SupportMail>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportSendEmail>}
     * @memberof SupportClaimDetails
     */
    sendEmails?: Array<SupportSendEmail>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportMessage>}
     * @memberof SupportClaimDetails
     */
    messages?: Array<SupportMessage>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportComment>}
     * @memberof SupportClaimDetails
     */
    comments?: Array<SupportComment>;
}

export function SupportClaimDetailsFromJSON(json: any): SupportClaimDetails {
    return {
            'claim': !exists(json, 'claim') ? undefined : SupportClaimFromJSON(json['claim']),
            'codings': !exists(json, 'codings') ? undefined : (json['codings'] as Array<any>).map(SupportCodingFromJSON),
            'hl7s': !exists(json, 'hl7s') ? undefined : (json['hl7s'] as Array<any>).map(SupportHL7MessageFromJSON),
            'collectionPayments': !exists(json, 'collectionPayments') ? undefined : (json['collectionPayments'] as Array<any>).map(SupportCollectionPaymentFromJSON),
            'payments': !exists(json, 'payments') ? undefined : (json['payments'] as Array<any>).map(SupportClaimPaymentFromJSON),
            'eligibilities': !exists(json, 'eligibilities') ? undefined : (json['eligibilities'] as Array<any>).map(SupportClaimEligibilityFromJSON),
            'statuses': !exists(json, 'statuses') ? undefined : (json['statuses'] as Array<any>).map(SupportStatusFromJSON),
            'professionals': !exists(json, 'professionals') ? undefined : (json['professionals'] as Array<any>).map(SupportProfessionalClaimFromJSON),
            'transmissions': !exists(json, 'transmissions') ? undefined : (json['transmissions'] as Array<any>).map(SupportClaimTransmissionFromJSON),
            'institutionals': !exists(json, 'institutionals') ? undefined : (json['institutionals'] as Array<any>).map(SupportInstitutionalClaimFromJSON),
            'documents': !exists(json, 'documents') ? undefined : (json['documents'] as Array<any>).map(SupportDocumentFromJSON),
            'sendFaxes': !exists(json, 'sendFaxes') ? undefined : (json['sendFaxes'] as Array<any>).map(SupportSendFaxFromJSON),
            'receiveFaxes': !exists(json, 'receiveFaxes') ? undefined : (json['receiveFaxes'] as Array<any>).map(SupportReceiveFaxFromJSON),
            'letters': !exists(json, 'letters') ? undefined : (json['letters'] as Array<any>).map(SupportLetterFromJSON),
            'invoices': !exists(json, 'invoices') ? undefined : (json['invoices'] as Array<any>).map(InvoiceFromJSON),
            'collectionInvoiceEvents': !exists(json, 'collectionInvoiceEvents') ? undefined : (json['collectionInvoiceEvents'] as Array<any>).map(SupportCollectionInvoiceEventFromJSON),
            'historicalTagRecords': !exists(json, 'historicalTagRecords') ? undefined : (json['historicalTagRecords'] as Array<any>).map(SupportTagRecordFromJSON),
            'phones': !exists(json, 'phones') ? undefined : (json['phones'] as Array<any>).map(SupportPhoneFromJSON),
            'aiPhones': !exists(json, 'aiPhones') ? undefined : (json['aiPhones'] as Array<any>).map(SupportAIPhoneFromJSON),
            'mails': !exists(json, 'mails') ? undefined : (json['mails'] as Array<any>).map(SupportMailFromJSON),
            'sendEmails': !exists(json, 'sendEmails') ? undefined : (json['sendEmails'] as Array<any>).map(SupportSendEmailFromJSON),
            'messages': !exists(json, 'messages') ? undefined : (json['messages'] as Array<any>).map(SupportMessageFromJSON),
            'comments': !exists(json, 'comments') ? undefined : (json['comments'] as Array<any>).map(SupportCommentFromJSON),
    };

}

export function SupportClaimDetailsToForm(value?: SupportClaimDetails): any {
    let jsonVal = SupportClaimDetailsToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportClaimDetailsToJSON(value?: SupportClaimDetails): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'claim': SupportClaimToJSON(value.claim),
            'codings': (value.codings === undefined || value.codings === null) ? undefined : (value.codings as Array<any>).map(SupportCodingToJSON),
            'hl7s': (value.hl7s === undefined || value.hl7s === null) ? undefined : (value.hl7s as Array<any>).map(SupportHL7MessageToJSON),
            'collectionPayments': (value.collectionPayments === undefined || value.collectionPayments === null) ? undefined : (value.collectionPayments as Array<any>).map(SupportCollectionPaymentToJSON),
            'payments': (value.payments === undefined || value.payments === null) ? undefined : (value.payments as Array<any>).map(SupportClaimPaymentToJSON),
            'eligibilities': (value.eligibilities === undefined || value.eligibilities === null) ? undefined : (value.eligibilities as Array<any>).map(SupportClaimEligibilityToJSON),
            'statuses': (value.statuses === undefined || value.statuses === null) ? undefined : (value.statuses as Array<any>).map(SupportStatusToJSON),
            'professionals': (value.professionals === undefined || value.professionals === null) ? undefined : (value.professionals as Array<any>).map(SupportProfessionalClaimToJSON),
            'transmissions': (value.transmissions === undefined || value.transmissions === null) ? undefined : (value.transmissions as Array<any>).map(SupportClaimTransmissionToJSON),
            'institutionals': (value.institutionals === undefined || value.institutionals === null) ? undefined : (value.institutionals as Array<any>).map(SupportInstitutionalClaimToJSON),
            'documents': (value.documents === undefined || value.documents === null) ? undefined : (value.documents as Array<any>).map(SupportDocumentToJSON),
            'sendFaxes': (value.sendFaxes === undefined || value.sendFaxes === null) ? undefined : (value.sendFaxes as Array<any>).map(SupportSendFaxToJSON),
            'receiveFaxes': (value.receiveFaxes === undefined || value.receiveFaxes === null) ? undefined : (value.receiveFaxes as Array<any>).map(SupportReceiveFaxToJSON),
            'letters': (value.letters === undefined || value.letters === null) ? undefined : (value.letters as Array<any>).map(SupportLetterToJSON),
            'invoices': (value.invoices === undefined || value.invoices === null) ? undefined : (value.invoices as Array<any>).map(InvoiceToJSON),
            'collectionInvoiceEvents': (value.collectionInvoiceEvents === undefined || value.collectionInvoiceEvents === null) ? undefined : (value.collectionInvoiceEvents as Array<any>).map(SupportCollectionInvoiceEventToJSON),
            'historicalTagRecords': (value.historicalTagRecords === undefined || value.historicalTagRecords === null) ? undefined : (value.historicalTagRecords as Array<any>).map(SupportTagRecordToJSON),
            'phones': (value.phones === undefined || value.phones === null) ? undefined : (value.phones as Array<any>).map(SupportPhoneToJSON),
            'aiPhones': (value.aiPhones === undefined || value.aiPhones === null) ? undefined : (value.aiPhones as Array<any>).map(SupportAIPhoneToJSON),
            'mails': (value.mails === undefined || value.mails === null) ? undefined : (value.mails as Array<any>).map(SupportMailToJSON),
            'sendEmails': (value.sendEmails === undefined || value.sendEmails === null) ? undefined : (value.sendEmails as Array<any>).map(SupportSendEmailToJSON),
            'messages': (value.messages === undefined || value.messages === null) ? undefined : (value.messages as Array<any>).map(SupportMessageToJSON),
            'comments': (value.comments === undefined || value.comments === null) ? undefined : (value.comments as Array<any>).map(SupportCommentToJSON),
    };
}


